module.exports = __webpack_public_path__ + "img/Aio-Light-Transparent-600px.a69e8d26.png";